import CloseIcon from '@mui/icons-material/Close';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Box, Collapse, IconButton, ListItemIcon, Typography } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import React, { useState } from 'react';
import { Link, NavLink, useMatch, useResolvedPath } from 'react-router-dom';
import { MenuLinkItem } from '../../../hooks/useMenuItems';
import { sidebarDrawerStyles } from './sidebarDrawerStyles';
import { ROUTE_PATHS } from '../../../routes/Routes';
import LegaleseLinks from './LegaleseLinks';

interface ISidebarDrawerMobileContentProps {
  setSidebarOpen(open: boolean): void;
  menuItems: MenuLinkItem[];
}
const SIDEBAR_DRAWER_WIDTH = 240;

const SidebarDrawerMobileContent: React.FC<ISidebarDrawerMobileContentProps> = ({ setSidebarOpen, menuItems }) => {
  const [openSubMenu, setOpenSubMenu] = useState<string | null>('Setup');

  const closeSidebar = () => setSidebarOpen(false);

  const handleSubMenuClick = (label: string) => {
    setOpenSubMenu(openSubMenu === label ? null : label);
  };

  const handleMenuItemClick = (link: string | undefined) => {
    if (link) {
      closeSidebar(); // Close the sidebar only when a leaf item is clicked
    }
  };

  const renderMenuItems = (items: MenuLinkItem[]) => {
    return items.map((linkObj) => {
      const resolved = useResolvedPath(linkObj.link || '/');
      const isActive = !!useMatch({ path: resolved.pathname, end: false });

      if (linkObj.children) {
        const isSubMenuOpen = openSubMenu === linkObj.label;
        return (
          <React.Fragment key={linkObj.label}>
            <ListItem disablePadding>
              <ListItemButton onClick={() => handleSubMenuClick(linkObj.label)} sx={sidebarDrawerStyles.listItemButtonMobile}>
                <ListItemIcon sx={sidebarDrawerStyles.listItemIconMobile(isActive)}>{linkObj.icon}</ListItemIcon>
                <Box sx={sidebarDrawerStyles.listItemButtonContent}>
                  <Typography sx={sidebarDrawerStyles.listItemTextMobile(isActive)}>{linkObj.label}</Typography>
                  {isSubMenuOpen ? <ExpandLess sx={{ color: 'var(--primary-light)' }} /> : <ExpandMore sx={{ color: 'var(--primary-light)' }} />}
                </Box>
              </ListItemButton>
            </ListItem>
            <Collapse in={isSubMenuOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding sx={{ pl: 2 }}>
                {renderMenuItems(linkObj.children)}
              </List>
            </Collapse>
          </React.Fragment>
        );
      }

      return (
        <ListItem key={linkObj.label} disablePadding>
          <ListItemButton
            component={NavLink}
            to={linkObj.link || ''}
            sx={sidebarDrawerStyles.listItemButtonMobile}
            onClick={() => handleMenuItemClick(linkObj.link)}
          >
            <ListItemIcon sx={sidebarDrawerStyles.listItemIconMobile(isActive)}>{linkObj.icon}</ListItemIcon>
            <Typography sx={sidebarDrawerStyles.listItemTextMobile(isActive)}>{linkObj.label}</Typography>
          </ListItemButton>
        </ListItem>
      );
    });
  };

  return (
    <Box sx={{ ...sidebarDrawerStyles.container, ...sidebarDrawerStyles.mobileContainer }}>
      <Box sx={sidebarDrawerStyles.headerBoxMobile}>
        <Link to={ROUTE_PATHS.DASHBOARD}>
          <img src="/svg/schedulink_logo.svg" alt="logo" onClick={closeSidebar} style={{ width: '30px', height: '30px' }} />
        </Link>
        <IconButton onClick={closeSidebar}>
          <CloseIcon color="secondary" />
        </IconButton>
      </Box>
      <Box sx={{ ...sidebarDrawerStyles.itemsContainer, width: SIDEBAR_DRAWER_WIDTH }} role="presentation">
        <List>{renderMenuItems(menuItems)}</List>
        <LegaleseLinks />
      </Box>
    </Box>
  );
};

export default SidebarDrawerMobileContent;
